import React, { Component, Fragment } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import withStyles from '@mui/styles/withStyles';
import gql from 'graphql-tag';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import Button from '../../components/form/Button';
import ViewHeader from '../../components/header/ViewHeader';
import FilterModal from './Modals/FilterModal';
import { getBrandHomeByKey } from '../../utils/brands';
import DataTable from '../../components/dataTable/DataTable';
import { joinDefined, PAGE_ORDER_REQUESTS, prettyPhone } from '../../utils/strings';
import { getProperty } from '../../utils/objects';
import { niceDateFromString, niceTimeFromString, shortDateFromString } from '../../utils/date';
import AttentionDot from '../../components/table/AttentionDot';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from '../../components/ErrorFallback';

class CremationPendingList extends Component {
    state = {
        showFilterModal: false
    };

    render() {
        const { showFilterModal } = this.state;

        return (
            <Grid container className="sticky-table">
                <Grid item>{this.renderHeader()}</Grid>
                <Grid item>
                    <Paper elevation={0}>
                        <Grid item>{this.renderCremationListingsTable()}</Grid>
                    </Paper>
                </Grid>
                <FilterModal
                    open={!!showFilterModal}
                    anchorEl={showFilterModal}
                    onClose={() => this.setState({ showFilterModal: false })}
                />
            </Grid>
        );
    }

    renderHeader() {
        return (
            <ViewHeader title="Bookings" subtitle="Booking Requests">
                {/*<Button*/}
                {/*	variant="primary"*/}
                {/*	size="lg"*/}
                {/*	onClick={event =>*/}
                {/*		this.setState({ showFilterModal: event.currentTarget })*/}
                {/*	}*/}
                {/*>*/}
                {/*	<FilterIcon />*/}
                {/*	Filter*/}
                {/*</Button>*/}
            </ViewHeader>
        );
    }

    renderCremationListingsTable() {
        const filters = [
            { field: 'CremationPending', value: '1' },
            { field: 'CremationCancelled', value: '0' }
        ];
        return (
            <Fragment>
                <Grid item>
                    <Grid container>
                        <Grid item>
                            <DataTable
                                dataObject="CremationOrder"
                                queryName="readCremationOrders"
                                fragment={cremationFragment}
                                isFilterable={['Brand']}
                                isSortable
                                columns={cremationRequestColumns}
                                variables={{ filters, filterBy: [] }}
                                brandProperty="LegacyKey" //the property to determine the brand from
                                searchVariable="contains"
                                noFiltersTitle="All Pending Requests"
                                showFlags
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }
}

const cremationRequestColumns = [
    {
        label: 'Funeral Ref',
        propertyPath: 'LegacyKey',
        renderCell: (row, value) =>
            <Button href={PAGE_ORDER_REQUESTS + row.ID} variant="link-orange">
                {value || row.ID}
            </Button>

    },
    {
        label: 'Deceased',
        propertyPath: 'Deceased.Surname',
        renderCell: row => <span>{row.NameOfDeceased}</span>
    },
    {
        label: 'Requested Delivery',
        propertyPath: 'CremationDate',
        renderCell: row => <>{shortDateFromString(row.CremationDate)}<br />{niceTimeFromString(row.CremationTime)}</>

    },
    {
        label: 'Status',
        propertyPath: 'Status',
        renderCell: (row, value) => {
            const approvedAllRequiredDocs = !row.HasMissingCertificates;
            const urgent = !row.ReadyForCremation && !!row.DeliveryDate;
            const ignore = !!row.CremationCancelled || !!row.CremationComplete;
            return (
                <>
                    <div className="attention-list">
                        {(!ignore && (!approvedAllRequiredDocs || !!urgent) && <AttentionDot variant="urgent" />)}
                        {(!!row.SameDayCremation && <AttentionDot variant="sameday" />)}
                        {(!!row.NextDayCremation && <AttentionDot variant="nextday" />)}
                        {('Required' === row.WitnessOfInsertionRequired) && <AttentionDot variant="woi" />}
                        {('Required' === row.ReflectionRoomRequired) && <AttentionDot variant="viewing" />}
                    </div>
                    {value}
                </>
            );
        }
    },
    {
        label: 'Applicant',
        propertyPath: 'Client.Surname',
        renderCell: row => (
            <span>
                {row.Client && joinDefined([row.Client.FirstName, row.Client.MiddleName, row.Client.Surname], ' ')}
                {row.Client &&
                    (row.Client.PrimaryNumber || row.Client.SecondaryNumber) &&
                    (row.Client.FirstName || row.Client.MiddleName || row.Client.Surname) &&
                    <br />}
                {row.Client && prettyPhone(joinDefined([row.Client.PrimaryNumber, row.Client.SecondaryNumber], ' / '), false)}
            </span>
        )
    },
    {
        label: 'Date of Service',
        propertyPath: 'Funeral.DateOfService',
        renderCell: row => <span>{row.Funeral && niceDateFromString(row.Funeral.DateOfService)}</span>
    },
    {
        label: 'Brand',
        renderCell: row => <span>{getBrandHomeByKey(getProperty(row, 'LegacyKey')).label}</span>
    }
];

const cremationFragment = gql`
    fragment CremationOrderPending on CremationOrder {
        ID
        LegacyKey
        CremationDate
        CremationTime
        CremationCancelled
        CremationComplete
        HasMissingCertificates
        NameOfDeceased
        ReflectionRoomRequired
        Status
        SameDayCremation
        NextDayCremation
        WitnessOfInsertionRequired
        Funeral {
            ID
            LegacyKey
            DateOfService
        }
        Client {
            ID
            FirstName
            MiddleName
            Surname
            PrimaryNumber
            SecondaryNumber
            Email
        }
    }
`;

export default withErrorBoundary(compose(withRouter, withStyles({}))(CremationPendingList), { fallback: ErrorFallback });
